import service from '@/utils/request'; // 类目-获取所有类目
// @Tags GoodsManage
// @Summary 获取所有类目
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取所有类目"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/category/getList [get]

export var getGoodsCategoryList = function getGoodsCategoryList(params) {
  return service({
    url: '/shopManage/category/getList',
    method: 'get',
    params: params
  });
}; // 类目-更新
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/category/update [post]

export var updateGoodsCategory = function updateGoodsCategory(data) {
  return service({
    url: '/shopManage/category/update',
    method: 'post',
    data: data
  });
}; // 类目-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/category/create [post]

export var createGoodsCategory = function createGoodsCategory(data) {
  return service({
    url: '/shopManage/category/create',
    method: 'post',
    data: data
  });
}; // 类目-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/category/delete [delete]

export var deleteGoodsCategory = function deleteGoodsCategory(data) {
  return service({
    url: '/shopManage/category/delete',
    method: 'post',
    data: data
  });
}; // 供应商-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/supplier/getList [get]

export var getSupplierList = function getSupplierList(params) {
  return service({
    url: '/shopManage/supplier/getList',
    method: 'get',
    params: params
  });
}; // 供应商-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/supplier/create [post]

export var createSupplier = function createSupplier(data) {
  return service({
    url: '/shopManage/supplier/create',
    method: 'post',
    data: data
  });
}; // 供应商-更新
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/supplier/update [post]

export var updateSupplier = function updateSupplier(data) {
  return service({
    url: '/shopManage/supplier/update',
    method: 'post',
    data: data
  });
}; // 供应商-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/supplier/delete [delete]

export var deleteSupplier = function deleteSupplier(data) {
  return service({
    url: '/shopManage/supplier/delete',
    method: 'post',
    data: data
  });
}; // 便利店-分页获取列表-根据账号权限控制
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/seller/getList [get]

export var getSellerList = function getSellerList(params) {
  return service({
    url: '/shopManage/seller/getList',
    method: 'get',
    params: params
  });
}; // 便利店-分页获取列表-获取所有，没有权限控制
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/seller/getAllList [get]

export var getSellerAllList = function getSellerAllList(params) {
  return service({
    url: '/shopManage/seller/getAllList',
    method: 'get',
    params: params
  });
}; // 便利店-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/seller/create [post]

export var createSeller = function createSeller(data) {
  return service({
    url: '/shopManage/seller/create',
    method: 'post',
    data: data
  });
}; // 便利店-更新
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/seller/update [post]

export var updateSeller = function updateSeller(data) {
  return service({
    url: '/shopManage/seller/update',
    method: 'post',
    data: data
  });
}; // 便利店-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/seller/delete [delete]

export var deleteSeller = function deleteSeller(data) {
  return service({
    url: '/shopManage/seller/delete',
    method: 'post',
    data: data
  });
}; // 库存-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goods/getList [get]

export var getGoodsList = function getGoodsList(params) {
  return service({
    url: '/shopManage/goods/getList',
    method: 'get',
    params: params
  });
}; // 库存-变更销售价
// @Tags GoodsManage
// @Summary 变更销售价
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更销售价"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goods/update [get]

export var updateGoodsPrice = function updateGoodsPrice(data) {
  return service({
    url: '/shopManage/goods/update',
    method: 'post',
    data: data
  });
}; // 库存明细-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsdetail/getList [get]

export var getGoodsdetailList = function getGoodsdetailList(params) {
  return service({
    url: '/shopManage/goodsdetail/getList',
    method: 'get',
    params: params
  });
}; // 库存导出
// @Tags GoodsManage
// @Summary 库存导出
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "库存导出"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goods/download [post]

export var postGoodsExport = function postGoodsExport(data) {
  return service({
    url: '/shopManage/goods/download',
    method: 'post',
    data: data
  });
}; // 商品库-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodspu/getList [get]

export var getGoodsspuList = function getGoodsspuList(params) {
  return service({
    url: '/shopManage/goodspu/getList',
    method: 'get',
    params: params
  });
}; // 商品库-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodspu/create [post]

export var createGoodsspu = function createGoodsspu(data) {
  return service({
    url: '/shopManage/goodspu/create',
    method: 'post',
    data: data
  });
}; // 商品库-更新
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodspu/update [post]

export var updateGoodsspu = function updateGoodsspu(data) {
  return service({
    url: '/shopManage/goodspu/update',
    method: 'post',
    data: data
  });
}; // 商品库-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodspu/delete [delete]

export var deleteGoodsspu = function deleteGoodsspu(data) {
  return service({
    url: '/shopManage/goodspu/delete',
    method: 'post',
    data: data
  });
}; // 入库-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/getList [get]

export var getGoodsinList = function getGoodsinList(params) {
  return service({
    url: '/shopManage/goodsin/getList',
    method: 'get',
    params: params
  });
}; // 入库-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/create [post]

export var goodsinCreate = function goodsinCreate(data) {
  return service({
    url: '/shopManage/goodsin/create',
    method: 'post',
    data: data
  });
}; // 入库-更新
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/update [post]

export var goodsinUpdate = function goodsinUpdate(data) {
  return service({
    url: '/shopManage/goodsin/update',
    method: 'post',
    data: data
  });
}; // 入库-提交审核
// @Tags GoodsManage
// @Summary 提交审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "提交审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/submit [post]

export var goodsinSubmit = function goodsinSubmit(data) {
  return service({
    url: '/shopManage/goodsin/submit',
    method: 'post',
    data: data
  });
}; // 入库-审核
// @Tags GoodsManage
// @Summary 审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/check [post]

export var goodsinCheck = function goodsinCheck(data) {
  return service({
    url: '/shopManage/goodsin/check',
    method: 'post',
    data: data
  });
}; // 入库-根据批次号查询明细
// @Tags GoodsManage
// @Summary 根据批次号查询入库明细
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "根据批次号查询入库明细"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/find [get]

export var goodsinFind = function goodsinFind(params) {
  return service({
    url: '/shopManage/goodsin/find',
    method: 'get',
    params: params
  });
}; // 入库-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsin/delete [post]

export var goodsinDelete = function goodsinDelete(data) {
  return service({
    url: '/shopManage/goodsin/delete',
    method: 'post',
    data: data
  });
}; // 入库-复制
// @Tags GoodsManage
// @Summary 入库-复制
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "入库-复制"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodsin/rollback [post]

export var goodsinCopy = function goodsinCopy(data) {
  return service({
    url: '/shopManage/goodsin/rollback',
    method: 'post',
    data: data
  });
}; // 盘点-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/getList [get]

export var getGoodsCheckList = function getGoodsCheckList(params) {
  return service({
    url: '/shopManage/goodscheck/getList',
    method: 'get',
    params: params
  });
}; // 盘点-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/create [post]

export var goodscheckCreate = function goodscheckCreate(data) {
  return service({
    url: '/shopManage/goodscheck/create',
    method: 'post',
    data: data
  });
}; // 盘点-变更
// @Tags GoodsManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/update [post]

export var goodsCheckUpdate = function goodsCheckUpdate(data) {
  return service({
    url: '/shopManage/goodscheck/update',
    method: 'post',
    data: data
  });
}; // 盘点-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodscheck/delete [delete]

export var deleteGoodscheck = function deleteGoodscheck(data) {
  return service({
    url: '/shopManage/goodscheck/delete',
    method: 'post',
    data: data
  });
}; // 盘点-获取明细列表
// @Tags GoodsManage
// @Summary 获取明细列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取明细列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/find [get]

export var goodsCheckFind = function goodsCheckFind(params) {
  return service({
    url: '/shopManage/goodscheck/find',
    method: 'get',
    params: params
  });
}; // 盘点-提交审核
// @Tags GoodsManage
// @Summary 提交审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "提交审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/submit [post]

export var goodsCheckSubmit = function goodsCheckSubmit(data) {
  return service({
    url: '/shopManage/goodscheck/submit',
    method: 'post',
    data: data
  });
}; // 盘点-审核
// @Tags GoodsManage
// @Summary 审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodscheck/check [post]

export var goodsCheck = function goodsCheck(data) {
  return service({
    url: '/shopManage/goodscheck/check',
    method: 'post',
    data: data
  });
}; // 账目调整-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/getList [get]

export var getGoodsOutList = function getGoodsOutList(params) {
  return service({
    url: '/shopManage/goodsout/getList',
    method: 'get',
    params: params
  });
}; // 账目调整-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/create [post]

export var goodsOutCreate = function goodsOutCreate(data) {
  return service({
    url: '/shopManage/goodsout/create',
    method: 'post',
    data: data
  });
}; // 账目调整-变更
// @Tags GoodsManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/update [post]

export var goodsOutUpdate = function goodsOutUpdate(data) {
  return service({
    url: '/shopManage/goodsout/update',
    method: 'post',
    data: data
  });
}; // 账目调整-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodsout/delete [delete]

export var deleteGoodsOut = function deleteGoodsOut(data) {
  return service({
    url: '/shopManage/goodsout/delete',
    method: 'post',
    data: data
  });
}; // 账目调整-获取明细列表
// @Tags GoodsManage
// @Summary 获取明细列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取明细列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/find [get]

export var goodsOutFind = function goodsOutFind(params) {
  return service({
    url: '/shopManage/goodsout/find',
    method: 'get',
    params: params
  });
}; // 账目调整-提交审核
// @Tags GoodsManage
// @Summary 提交审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "提交审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/submit [post]

export var goodsOutSubmit = function goodsOutSubmit(data) {
  return service({
    url: '/shopManage/goodsout/submit',
    method: 'post',
    data: data
  });
}; // 账目调整-审核
// @Tags GoodsManage
// @Summary 审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsout/check [post]

export var goodsOutCheck = function goodsOutCheck(data) {
  return service({
    url: '/shopManage/goodsout/check',
    method: 'post',
    data: data
  });
}; // 调拨-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/getList [get]

export var getGoodsAllocationList = function getGoodsAllocationList(params) {
  return service({
    url: '/shopManage/goodsallocation/getList',
    method: 'get',
    params: params
  });
}; // 调拨-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/create [post]

export var goodsAllocationCreate = function goodsAllocationCreate(data) {
  return service({
    url: '/shopManage/goodsallocation/create',
    method: 'post',
    data: data
  });
}; // 调拨-变更
// @Tags GoodsManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/update [post]

export var goodsAllocationUpdate = function goodsAllocationUpdate(data) {
  return service({
    url: '/shopManage/goodsallocation/update',
    method: 'post',
    data: data
  });
}; // 调拨-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodsallocation/delete [delete]

export var deleteGoodsAllocation = function deleteGoodsAllocation(data) {
  return service({
    url: '/shopManage/goodsallocation/delete',
    method: 'post',
    data: data
  });
}; // 调拨-获取明细列表
// @Tags GoodsManage
// @Summary 获取明细列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "获取明细列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/find [get]

export var goodsAllocationFind = function goodsAllocationFind(params) {
  return service({
    url: '/shopManage/goodsallocation/find',
    method: 'get',
    params: params
  });
}; // 调拨-提交审核
// @Tags GoodsManage
// @Summary 提交审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "提交审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/submit [post]

export var goodsAllocationSubmit = function goodsAllocationSubmit(data) {
  return service({
    url: '/shopManage/goodsallocation/submit',
    method: 'post',
    data: data
  });
}; // 调拨-审核
// @Tags GoodsManage
// @Summary 审核
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "审核"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/goodsallocation/check [post]

export var goodsAllocationCheck = function goodsAllocationCheck(data) {
  return service({
    url: '/shopManage/goodsallocation/check',
    method: 'post',
    data: data
  });
}; // 活动-分页获取列表
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/activity/getList [get]

export var getGoodsActivityList = function getGoodsActivityList(params) {
  return service({
    url: '/shopManage/activity/getList',
    method: 'get',
    params: params
  });
}; // 活动-新增
// @Tags GoodsManage
// @Summary 新增
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "新增"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/activity/create [post]

export var goodsActivityCreate = function goodsActivityCreate(data) {
  return service({
    url: '/shopManage/activity/create',
    method: 'post',
    data: data
  });
}; // 活动-变更
// @Tags GoodsManage
// @Summary 变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/activity/update [post]

export var goodsActivityUpdate = function goodsActivityUpdate(data) {
  return service({
    url: '/shopManage/activity/update',
    method: 'post',
    data: data
  });
}; // 活动-删除
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/activity/delete [delete]

export var deleteGoodsActivity = function deleteGoodsActivity(data) {
  return service({
    url: '/shopManage/activity/delete',
    method: 'post',
    data: data
  });
}; // 活动-启用禁用
// @Tags GoodsManage
// @Summary 启用禁用
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "启用禁用"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/activity/status [post]

export var goodsActivityStatus = function goodsActivityStatus(data) {
  return service({
    url: '/shopManage/activity/open',
    method: 'post',
    data: data
  });
}; // 导出盘点明细
// @Tags GoodsManage
// @Summary 启用禁用
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "导出盘点明细"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/goodscheck/download [post]

export var goodsCheckDownload = function goodsCheckDownload(data) {
  return service({
    url: '/shopManage/goodscheck/download',
    method: 'post',
    data: data
  });
}; // 线上商城-分页获取列表
// @Tags OnlineShop
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /onlineshop/goods/getList [get]

export var getOnlineShopGoodsList = function getOnlineShopGoodsList(params) {
  return service({
    url: '/onlineshop/goods/getList',
    method: 'get',
    params: params
  });
}; // 线上商城-查找
// @Tags OnlineShop
// @Summary 查找
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "查找"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/goods/find [post]

export var onlineShopGoodsFind = function onlineShopGoodsFind(data) {
  return service({
    url: '/onlineshop/goods/find',
    method: 'post',
    data: data
  });
}; // 线上商城-创建商品
// @Tags OnlineShop
// @Summary 创建商品
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "创建商品"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/goods/create [post]

export var createOnlineShopGoods = function createOnlineShopGoods(data) {
  return service({
    url: '/onlineshop/goods/create',
    method: 'post',
    data: data
  });
}; // 线上商城-更新商品
// @Tags OnlineShop
// @Summary 更新商品
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "更新商品"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/goods/update [post]

export var updateOnlineShopGoods = function updateOnlineShopGoods(data) {
  return service({
    url: '/onlineshop/goods/update',
    method: 'post',
    data: data
  });
}; // 线上商城-删除商品
// @Tags OnlineShop
// @Summary 删除商品
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除商品"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/goods/update [delete]

export var deleteOnlineShopGoods = function deleteOnlineShopGoods(data) {
  return service({
    url: '/onlineshop/goods/delete',
    method: 'post',
    data: data
  });
}; // 线上商城-分页获取列表
// @Tags OnlineShop
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /onlineshop/order/getList [get]

export var getOnlineShopOrderList = function getOnlineShopOrderList(params) {
  return service({
    url: '/onlineshop/order/getList',
    method: 'get',
    params: params
  });
}; // 线上商城-销售订单查找
// @Tags OnlineShop
// @Summary 销售订单查找
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "销售订单查找"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/order/find [post]

export var onlineShopOrderFind = function onlineShopOrderFind(data) {
  return service({
    url: '/onlineshop/order/find',
    method: 'post',
    data: data
  });
}; // 线上商城-删除订单
// @Tags OnlineShop
// @Summary 删除订单
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除订单"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/order/delete [delete]

export var deleteOnlineShopOrder = function deleteOnlineShopOrder(data) {
  return service({
    url: '/onlineshop/order/delete',
    method: 'post',
    data: data
  });
}; // 线上商城-变更订单
// @Tags OnlineShop
// @Summary 变更订单
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "变更订单"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/order/update [delete]

export var updateOnlineShopOrder = function updateOnlineShopOrder(data) {
  return service({
    url: '/onlineshop/order/update',
    method: 'post',
    data: data
  });
}; // 线上商城-分页获取列表
// @Tags OnlineShop
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /onlineshop/showarea/getList [get]

export var getOnlineShopAreaList = function getOnlineShopAreaList(params) {
  return service({
    url: '/onlineshop/showarea/getList',
    method: 'get',
    params: params
  });
}; // 线上商城-专区查找
// @Tags OnlineShop
// @Summary 专区查找
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "专区查找"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/showarea/find [post]

export var onlineShopAreaFind = function onlineShopAreaFind(data) {
  return service({
    url: '/onlineshop/showarea/find',
    method: 'post',
    data: data
  });
}; // 线上商城-删除专区
// @Tags OnlineShop
// @Summary 删除专区
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除专区"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/showarea/delete [delete]

export var deleteOnlineShopArea = function deleteOnlineShopArea(data) {
  return service({
    url: '/onlineshop/showarea/delete',
    method: 'post',
    data: data
  });
}; // 线上商城-专区创建
// @Tags OnlineShop
// @Summary 专区创建
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "专区创建"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/showarea/create [post]

export var onlineShopAreaCreate = function onlineShopAreaCreate(data) {
  return service({
    url: '/onlineshop/showarea/create',
    method: 'post',
    data: data
  });
}; // 线上商城-专区变更
// @Tags OnlineShop
// @Summary 专区变更
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "专区变更"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/showarea/update [post]

export var onlineShopAreaUpdate = function onlineShopAreaUpdate(data) {
  return service({
    url: '/onlineshop/showarea/update',
    method: 'post',
    data: data
  });
}; // 线上商城-商城装修
// @Tags OnlineShop
// @Summary 商城装修
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "商城装修"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/activity/getList [post]

export var getOnlineShopActivityList = function getOnlineShopActivityList(data) {
  return service({
    url: '/onlineshop/activity/getList',
    method: 'post',
    data: data
  });
}; // 线上商城-商城装修
// @Tags OnlineShop
// @Summary 商城装修
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "商城装修"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /onlineshop/activity/create [post]

export var onlineShopActivityCreate = function onlineShopActivityCreate(data) {
  return service({
    url: '/onlineshop/activity/create',
    method: 'post',
    data: data
  });
}; // 销售分析
// @Tags DataAnalyse
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/shopData/getList [get]

export var getShopDataAnalyse = function getShopDataAnalyse(params) {
  return service({
    url: '/shopManage/shopData/getList',
    method: 'get',
    params: params
  });
}; // 销售分析-目标保存
// @Tags DataAnalyse
// @Summary 目标保存
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "目标保存"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/shopData/update [post]

export var updateShopSaleMubiao = function updateShopSaleMubiao(data) {
  return service({
    url: '/shopManage/shopData/update',
    method: 'post',
    data: data
  });
}; // 销售分析-下载
// @Tags DataAnalyse
// @Summary 下载
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/shopData/download [post]

export var shopDataDownload = function shopDataDownload(data) {
  return service({
    url: '/shopManage/shopData/download',
    method: 'post',
    data: data
  });
}; // spu组合标签
// @Tags GoodsManage
// @Summary 分页获取列表
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "分页获取列表"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"获取成功"}"
// @Router /shopManage/spuGroup/getList [get]

export var getSpuGroupList = function getSpuGroupList(params) {
  return service({
    url: '/shopManage/spuGroup/getList',
    method: 'get',
    params: params
  });
}; // spu组合标签
// @Tags GoodsManage
// @Summary 更新
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/spuGroup/update [post]

export var updateSpuGroup = function updateSpuGroup(data) {
  return service({
    url: '/shopManage/spuGroup/update',
    method: 'post',
    data: data
  });
}; // spu组合标签
// @Tags GoodsManage
// @Summary 创建
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "下载"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/spuGroup/create [post]

export var createSpuGroup = function createSpuGroup(data) {
  return service({
    url: '/shopManage/spuGroup/create',
    method: 'post',
    data: data
  });
}; // spu组合标签
// @Tags GoodsManage
// @Summary 删除
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "删除"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/spuGroup/delete [post]

export var deleteSpuGroup = function deleteSpuGroup(data) {
  return service({
    url: '/shopManage/spuGroup/delete',
    method: 'post',
    data: data
  });
}; // spu组合标签
// @Tags GoodsManage
// @Summary 启用禁用
// @Security ApiKeyAuth
// @accept application/json
// @Produce application/json
// @Param data body true "启用禁用"
// @Success 200 {string} string "{"success":true,"data":{},"msg":"操作成功"}"
// @Router /shopManage/spuGroup/update/status [post]

export var updateSpuGroupStatus = function updateSpuGroupStatus(data) {
  return service({
    url: '/shopManage/spuGroup/update/status',
    method: 'post',
    data: data
  });
};